import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger)
export default function eAccess(){

    const listitem = document.querySelectorAll('.site-e-access .acc__nav a')
    gsap.utils.toArray('.site-e-access .acc__item').forEach((item, index) => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 80%',
        end: 'top 20%',

        onEnter: () => {
          listitem[index].classList.add('active');
        },

        onLeave: () => {
          listitem[index].classList.remove('active');
        },

        // 下から戻ってきたときも挙動を揃えるなら
        onEnterBack: () => {
          listitem[index].classList.add('active');
        },

        onLeaveBack: () => {
          listitem[index].classList.remove('active');
        },

        // 開発中だけ使う
        //markers: true,
      });
    });
  
}